import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import Reveal from "./Reveal";
import { BRAND } from "@/branding.config";

const T = [
  { quote: `We moved 40 EAs from a retail VPS to ${BRAND.company_name} and slippage dropped by 62% overnight. The support team actually knows what LD4 means.`,
    author: "Ravi K.", role: "Head of Execution, Aventide Capital" },
  { quote: `Windows Server on ${BRAND.company_name} boots faster than my laptop. Deploys are literally seconds. No config, no drama.`,
    author: "Marta L.", role: "SRE, Northwind Systems" },
  { quote: `We evaluated seven VPS providers before ${BRAND.company_name}. Only ${BRAND.company_name} sent us pcap dumps from their own edge probes. That's the level of transparency we needed.`,
    author: "Daniel O.", role: "CTO, HelixFX" },
];

export default function Testimonials() {
  return (
    <section className="mx-auto max-w-7xl px-6 py-24">
      <Reveal>
        <div className="text-xs uppercase tracking-[0.2em] text-primary font-bold">What operators say</div>
        <h2 className="mt-3 text-4xl md:text-5xl font-black tracking-tight max-w-3xl">The infrastructure that gets out of the way.</h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
        {T.map((t, i) => (
          <motion.div
            key={t.author}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.12 }}
            className="surface p-8 relative overflow-hidden"
          >
            <Quote size={22} className="text-primary/60" />
            <p className="mt-4 text-base leading-relaxed">{t.quote}</p>
            <div className="mt-6 pt-6 border-t border-white/[0.06]">
              <div className="font-semibold text-sm">{t.author}</div>
              <div className="text-xs text-muted-foreground">{t.role}</div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
